import {
    InitClient,
    GetByParas,
    Post,
    PostWithParas,
    PostNoParas
} from "../ZeusAPIClient.js";
import { apiConfig } from "../../config.js";
import { PagingBody } from "../Model/PagingBody";
import { Predicate } from "../Model/Predicate";
import { EncryptContent } from "../Logic/WikiLogic";
InitClient(apiConfig.clientId, apiConfig.clientSecret, apiConfig.host);

///获取部门和人员树状结构列表
async function GetFrameAndUserTreeList() {
    //3d18f5c3-f3a0-469c-b3ba-29d3108545bb	
    var data = {};
    return await GetByParas("3d18f5c3-f3a0-469c-b3ba-29d3108545bb", data);//PostWithParas("3d18f5c3-f3a0-469c-b3ba-29d3108545bb",{},null) GetByParas("3d18f5c3-f3a0-469c-b3ba-29d3108545bb",null);
}

///获取部门和人员树状结构列表
async function GetFrameAndUserCodeTreeList() {
    //3d18f5c3-f3a0-469c-b3ba-29d3108545bb	
    var data = {};
    return await GetByParas("d93f97b8-1b83-488f-b02c-20f77cba81ef", data);//PostWithParas("3d18f5c3-f3a0-469c-b3ba-29d3108545bb",{},null) GetByParas("3d18f5c3-f3a0-469c-b3ba-29d3108545bb",null);
}

///获取部门树状结构列表
async function GetFrameTreeList() {
    var data = {};
    return await GetByParas("1d917ac3-1dee-4f5b-829b-77ea54b9dbe1", data);//PostWithParas("3d18f5c3-f3a0-469c-b3ba-29d3108545bb",{},null) GetByParas("3d18f5c3-f3a0-469c-b3ba-29d3108545bb",null);
}
///获取部门树状结构列表(根据权限)
async function GetFrameTreeListByPer(userId, roleKey, frameId, otherFrameID, title, dataAuth, pageIndex, pageSize) {
    var data = {
        userId: userId,
        roleKey: roleKey,
        frameId: frameId,
        otherFrameID: otherFrameID,
        title: title,
        dataAuth: dataAuth,
        pageIndex: pageIndex,
        pageSize: pageSize
    };
    return await PostWithParas("4e21eef6-3b01-4d64-9909-f7fa2379e900", '', data);
}
///获取部门实体类
async function GetFrameInfo(id) {
    //3d18f5c3-f3a0-469c-b3ba-29d3108545bb	
    var data = {
        id: id,
    };
    return await GetByParas("c4c8fda3-9c87-4cdd-b991-b1fd17beafb0", data);//PostWithParas("3d18f5c3-f3a0-469c-b3ba-29d3108545bb",{},null) GetByParas("3d18f5c3-f3a0-469c-b3ba-29d3108545bb",null);
}

///获取钉钉部门实体类
async function GetDingFrameTreeList() {
    //3d18f5c3-f3a0-469c-b3ba-29d3108545bb	
    var data = {
    };
    return await GetByParas("ce91fe7f-a45a-4cf3-be4a-84fc81bcaad3", data);//PostWithParas("3d18f5c3-f3a0-469c-b3ba-29d3108545bb",{},null) GetByParas("3d18f5c3-f3a0-469c-b3ba-29d3108545bb",null);
}

///获取钉钉部门和人员实体类
async function GetDingFrameAndTreeList() {
    var data = {
    };
    return await GetByParas("4cee2ce0-2bff-4c73-9fbf-b36e67e31d52", data);//PostWithParas("3d18f5c3-f3a0-469c-b3ba-29d3108545bb",{},null) GetByParas("3d18f5c3-f3a0-469c-b3ba-29d3108545bb",null);
}

///获取邮箱部门实体类
async function GetTecentMailFrameTreeList() {
    //3d18f5c3-f3a0-469c-b3ba-29d3108545bb	
    var data = {
    };
    return await GetByParas("8f7ccb6d-c3ba-4849-87c9-115e235e6f8f", data);//PostWithParas("3d18f5c3-f3a0-469c-b3ba-29d3108545bb",{},null) GetByParas("3d18f5c3-f3a0-469c-b3ba-29d3108545bb",null);
}

///获取邮箱部门和人员实体类
async function GetTecentMailFrameAndUserTreeList() {
    var data = {
    };
    return await GetByParas("26b5d0f1-7046-4ec5-9240-5ea14601c764", data);
}

///获取企业微信部门实体类
async function GetWeChatFrameTreeList() {
    //3d18f5c3-f3a0-469c-b3ba-29d3108545bb	
    var data = {
    };
    return await GetByParas("11d17199-7618-42e1-8fc5-7769e01bb6f6", data);//PostWithParas("3d18f5c3-f3a0-469c-b3ba-29d3108545bb",{},null) GetByParas("3d18f5c3-f3a0-469c-b3ba-29d3108545bb",null);
}

///获取企业微信部门和人员实体类
async function GetWeChatFrameAndUserTreeList() {
    var data = {
    };
    return await GetByParas("c3294a28-a397-4b83-b47a-194a8a9929ad", data);//PostWithParas("3d18f5c3-f3a0-469c-b3ba-29d3108545bb",{},null) GetByParas("3d18f5c3-f3a0-469c-b3ba-29d3108545bb",null);
}

///获取SysItem数据
async function GetItem(id) {
    var data = {
        parentid: id,
    };
    return await GetByParas("19cb123f-b4a2-4497-a4d8-63bd978b5306", data);//PostWithParas("3d18f5c3-f3a0-469c-b3ba-29d3108545bb",{},null) GetByParas("3d18f5c3-f3a0-469c-b3ba-29d3108545bb",null);
}

//保存部门  baaaddbe-1be4-448c-a6b7-a1acb5829241
async function InsertFrameInfo(frameModel) {
    var data = await PostWithParas('baaaddbe-1be4-448c-a6b7-a1acb5829241', '', frameModel);
    if (data.Result == 1) {
        return true;
    }
    else {
        return false;
    }
}

//删除部门  
async function DeleteFrame(id) {
    var data = await PostWithParas('a9d0aa70-9da1-4243-bdc4-e7da3993bdba', '', id)

    if (data.Result == 1) {
        return true;
    }
    else {
        return false;
    }
}




//更新邮箱组织架构到E平台
async function GetupdateMailTreeDepts() {
    var data = {
    };
    return await GetByParas("1676a264-e8e0-4a3a-ad03-2c2990f3dbb8", data);
}


//更新钉钉组织架构到E平台
async function GetupdateDingTreeDepts() {

    var data = {
    };
    return await GetByParas("ac9737ee-7ff8-447e-baaa-4dc6ee07c216", data);
}

//更新企业微信组织架构到E平台
async function GetupdateEnterpriseWeChatTreeDepts() {

    var data = {
    };
    return await GetByParas("ff312fd7-8a78-4c61-a93f-cf1d6be32880", data);
}



export {
    GetFrameAndUserTreeList,
    GetFrameAndUserCodeTreeList,
    GetFrameTreeList,
    GetFrameInfo,
    InsertFrameInfo,
    GetItem,
    GetDingFrameTreeList,
    GetTecentMailFrameTreeList,
    GetWeChatFrameTreeList,
    DeleteFrame,
    GetTecentMailFrameAndUserTreeList,
    GetWeChatFrameAndUserTreeList,
    GetDingFrameAndTreeList,
    GetFrameTreeListByPer,
    GetupdateMailTreeDepts,//更新邮箱组织架构到E平台
    GetupdateDingTreeDepts,
    GetupdateEnterpriseWeChatTreeDepts,

}